/**
 * BadgeIcon — renders a Lucide icon by name for badge display
 */
import {
  GraduationCap, Dog, ClipboardCheck, Flame, Gem,
  PawPrint, Hand, Trophy, Star, BicepsFlexed,
  BookOpenCheck, MessageCircleHeart, House, GitFork,
  Footprints, Crown, Rocket, Medal, Target,
  Sunrise, Moon, Cat, CalendarCheck, Zap,
} from 'lucide-react';

const iconMap = {
  GraduationCap, Dog, ClipboardCheck, Flame, Gem,
  PawPrint, Hand, Trophy, Star, BicepsFlexed,
  BookOpenCheck, MessageCircleHeart, House, GitFork,
  Footprints, Crown, Rocket, Medal, Target,
  Sunrise, Moon, Cat, CalendarCheck, Zap,
};

const BadgeIcon = ({ name, size = 24, className = '' }) => {
  const IconComponent = iconMap[name];
  if (!IconComponent) return <span className={className}>{name}</span>;
  return <IconComponent size={size} className={className} />;
};

export default BadgeIcon;
